import React from "react";
import styles from "./style.module.css";
import paris from "../../../assets/images/paris.png";
import singapore from "../../../assets/images/singapore.png";
import vietnam from "../../../assets/images/vietnam.jpg";

function Destinations() {
  return (
   <>
   <div className="container-fluid">
   <div className={styles.destinations}>
  <h2>Enjoy mobile internet in over 190 destinations</h2>
  <div className={styles.grid}>
    <div className={styles.big}>
      <img src={paris} alt="Paris" />
    </div>
    <div className={styles.small}>
      <img src={singapore} alt="Singapore" />
      <img src={vietnam} alt="Vietnam" />
    </div>
  </div>
</div>
</div>
</>
  );
}

export default Destinations;
